module.exports = __webpack_public_path__ + "static/media/aikBankLogo.4cb86e0a.png";